/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { LinkedRef } from './LinkedRef';

export const Presentation: core.serialization.ObjectSchema<serializers.Presentation.Raw, Truvity.Presentation> =
    core.serialization.object({
        digestMultibase: core.serialization.property('digest_multibase', core.serialization.string()),
        id: core.serialization.string(),
        linkedCredentialRefs: core.serialization.property(
            'linked_credential_refs',
            core.serialization.list(LinkedRef).optional(),
        ),
        type: core.serialization.list(core.serialization.string()),
    });

export declare namespace Presentation {
    export interface Raw {
        digest_multibase: string;
        id: string;
        linked_credential_refs?: LinkedRef.Raw[] | null;
        type: string[];
    }
}
